/**
 * Assignment status predicates.
 *
 * The status machine is:
 * pending → notified → accepted | declined | cancelled.
 *
 * Go↔TS sync: isActive / isRenotifyTarget mirror
 * go-service/internal/assignment (IsActive / IsRenotifyTarget) — keep the two
 * in lockstep. The Go side is a superset (WasOffered / CanRespond /
 * AllAccepted / CrewTally) used by the backend handlers. See CONTEXT.md →
 * "Assignment status".
 */

export type AssignmentStatus =
  "pending" | "notified" | "accepted" | "declined" | "cancelled";

export interface AssignmentLike {
  status: string;
}

/** Active = part of the current crew. Excludes declined + cancelled. */
export function isActive(assignment: AssignmentLike): boolean {
  return assignment.status !== "cancelled" && assignment.status !== "declined";
}

/** Renotify scope — wider than active: includes previously-declined. */
export function isRenotifyTarget(assignment: AssignmentLike): boolean {
  return assignment.status !== "cancelled";
}
